import React from 'react';
import { Button, Stack, alpha, useTheme, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import { ScaleAnimation } from '../../animations/MotionWrapper';
import { ROUTES } from '../../../constants/routes';

/**
 * AuthButtons - Login button for non-authenticated users
 * Displays authentication option in the navbar (desktop view only)
 */
const AuthButtons = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  // In mobile view, these will be in the drawer
  if (isMobile) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ ml: 'auto' }}
    >
      <ScaleAnimation>
        <Button
          component={Link}
          to={ROUTES.LOGIN}
          startIcon={!isSmall && <LoginIcon />}
          sx={{
            color: theme.palette.common.white,
            fontWeight: 500,
            px: { xs: 1.5, sm: 2 },
            py: 1,
            borderRadius: 2,
            whiteSpace: 'nowrap',
            minWidth: isSmall ? 40 : 100,
            '&:hover': {
              backgroundColor: alpha(theme.palette.common.white, 0.1),
            },
          }}
        >
          {isSmall ? <LoginIcon /> : 'Anmelden'}
        </Button>
      </ScaleAnimation>
    </Stack>
  );
};

export default AuthButtons;
